import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	Heading,
	BorderLine,
	Description,
	LastSearchBar,
	SubHeading
} from "components/storages/Common";
import {
	HELP_PAGE_DATA,
	MAIN_HEADINGS
} from "components/storages/ContentData/HelpPageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import BlogPosts from "components/storages/Common/BlogPosts";
import { useSelector } from "react-redux";

function HelpPage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			className="storage-page"
			title="Help Center - Storage.com"
			description=""
			canonical={`${baseUrl}/help/`}
		>
			<Container>
				<StorageHeader heading="Find Cheap Storage Near You!" />
				<Heading content={MAIN_HEADINGS.first} />
				<div className="all-sections custom-gap">
					{HELP_PAGE_DATA?.map((item) => (
						<>
							<SubHeading title={item.title} />
							<Description desc={item.desc} />
							{item.descLinkMultiple && (
								<Description
									descLinkMultiple={item.descLinkMultiple}
								/>
							)}
							<div className="custom-margin" />
						</>
					))}
					<LastSearchBar />
				</div>
				<BorderLine />
				<Heading content={MAIN_HEADINGS.second} />
				<BlogPosts />
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default HelpPage;
